export function isRecord<B>(value: unknown): value is Record<string, B> {
    return typeof value === 'object' && value !== null;
}